<template>
  <van-popover
    v-bind="$attrs"
    v-on="$listeners"
    :placement="placement"
    trigger="click"
  >
    <ul class="select-panel">
      <li
        @click="handleSelectItem(item)"
        v-for="(item, index) in selectList"
        :key="index"
        :class="[
          item.disabled && 'disabled',
          'panel-item',
          matchLabelActive(item.value, currentValue) && 'active',
        ]"
      >
        {{ item.name }}
        <slot v-if="item.type == 'customDate'" name="date"></slot>
      </li>
    </ul>
    <template #reference>
      <span :class="['select-button', 'ellipsis', $attrs.value && 'active']">
        <template v-if="hasDiv">
          <div>
            <span v-if="label" class="label">{{ label }}</span>
            <span v-if="labelDateMode && !dateValue"
              >{{
                $slots.date
                  ? labelName.replace('自定义', '').replace('全部', '')
                  : labelName
              }}
              <slot v-if="labelDateMode" name="date"></slot
            ></span>
            <span v-else-if="dateValue">{{ dateValue }}</span>
            <span v-else>{{ labelName }} </span>
            <img src="@/assets/images/agent/select-arrow.png" />
          </div>
        </template>
        <template v-else>
          <span v-if="label" class="label">{{ label }}</span>
          <span v-if="labelDateMode && !dateValue"
            >{{
              $slots.date
                ? labelName.replace('自定义', '').replace('全部', '')
                : labelName
            }}
            <slot v-if="labelDateMode" name="date"></slot
          ></span>
          <span v-else-if="dateValue">{{ dateValue }}</span>
          <span v-else>{{ customLabelName || labelName }} </span>
          <img src="@/assets/images/agent/select-arrow.png" />
        </template>
      </span>
    </template>
  </van-popover>
</template>

<script>
export default {
  name: 'CustomSelect',
  props: {
    selectList: Array,
    selectValue: [String, Number, Array],
    label: String,
    dateValue: String,
    placement: {
      type: String,
      default: () => {
        return 'bottom-start'
      },
    },
    multiple: Boolean,
    labelDateMode: Boolean,
    customLabelName: String,
    hasDiv: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {}
  },
  computed: {
    currentValue: {
      get() {
        return this.$props.selectValue
      },
      set(val) {
        this.$emit('update:selectValue', val)
      },
    },
    labelName() {
      try {
        if (this.multiple) {
          let selectName = this.selectList
            .filter(item => this.currentValue.includes(item.value))
            .map(item => item.name)
          return selectName.length
            ? `${selectName[0]}${
                selectName.length - 1 == 0 ? '' : `·${selectName.length - 1}`
              }`
            : '全部'
        } else {
          return this.selectList.filter(item => {
            if (
              Array.isArray(this.currentValue) &&
              Array.isArray(item.value) &&
              !this.multiple
            ) {
              return this.currentValue.join(',') == item.value.join(',')
            } else {
              return item.value === this.currentValue
            }
          })[0].name
        }
      } catch (e) {
        return '全部'
      }
    },
  },
  methods: {
    matchLabelActive(currentValue, labelValue) {
      if (
        Array.isArray(currentValue) &&
        Array.isArray(labelValue) &&
        !this.multiple
      ) {
        return currentValue.join(',') == labelValue.join(',')
      } else if (this.multiple) {
        return this.currentValue.includes(currentValue)
      } else {
        return currentValue === labelValue
      }
    },
    handleSelectItem(item) {
      if (item.disabled) {
        return
      }
      if (this.multiple) {
        if (this.currentValue.includes(item.value)) {
          let index = this.currentValue.findIndex(itm => itm == item.value)
          this.currentValue.splice(index, 1)
        } else {
          this.currentValue.push(item.value)
        }
      } else {
        this.currentValue = item.value
      }
      this.$emit('change', this.multiple ? this.currentValue : item.value)
      this.$emit('input', false)
    },
  },
}
</script>
<style>
.van-popover--light .van-popover__arrow {
  color: transparent !important;
}
</style>
<style lang="scss" scoped>
.select-panel {
  min-width: 160px;
  height: auto;
  background: #ffffff;
  box-shadow: 0px 10 60px 20px rgba(32, 33, 36, 0.08);
  border-radius: 12px;
  padding: 0 16px;
  box-sizing: border-box;
  .panel-item {
    width: 100%;
    padding: 16px 0;
    box-sizing: border-box;
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 14px;
    font-size: var(--set-font-size14);
    color: #202124;
    line-height: 1.428;
    text-align: left;
    font-style: normal;
    &.disabled {
      color: #c0c4cc;
    }
    &.active {
      color: #006cff;
    }
    &:not(:last-of-type) {
      border-bottom: 1px solid #f5f6f7;
    }
  }
}
.select-button {
  display: flex;
  align-items: center;
  padding: 8px 8px 8px 14px;
  box-sizing: border-box;
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  font-size: 13px;
  font-size: var(--set-font-size13);
  color: #202124;
  line-height: 1;
  text-align: right;
  font-style: normal;
  background: #ffffff;
  border-radius: 6px;
  border: 1px solid transparent;
  .label {
    color: var(--color-Text-text-primary3, #919499);
    /* 正文·13/13·Regular */
    font-family: 'PingFang SC';
    font-style: normal;
    font-weight: 400;
    line-height: 20px; /* 153.846% */
    margin-right: 10px;
  }
  &.active {
    border-color: #006cff;
    img {
      transform: rotate(180deg);
      transform-origin: center center;
    }
  }
  img {
    width: 8px;
    height: 6px;
    margin-left: 6px;
    transition: transform 0.3s;
    transform: rotate(0);
  }
}
.time {
  font-family: PingFang SC, PingFang SC;
  font-weight: 400;
  font-size: 12px;
  font-size: var(--set-font-size12);
  color: #202124;
  line-height: 1.666;
}
</style>
